export default {
  orderDetails: {},
  selectedOrder: {},
};
